import { Link } from "react-router-dom";
import { Lock } from "@phosphor-icons/react";

// Full-page Season Pass preview for Sprint racers, intentional, never "broken".
export const SeasonLockedScreen = ({ id, icon, title, body, bullets = [], ctaLabel = "Start My 52-Week Payday Relay Race", backTo = "/app" }) => (
  <div className="min-h-screen flex items-center justify-center px-6" style={{ background: "var(--pr-bg)" }}>
    <div className="max-w-md w-full" data-testid={id}>
      <div className="rounded-3xl border border-dashed p-6 sm:p-8 text-center" style={{ background: "var(--pr-bg-alt)", borderColor: "var(--pr-card-line)" }}>
        <div className="text-5xl mb-3 opacity-60 grayscale">{icon}</div>
        <p className="inline-flex items-center gap-1.5 text-[10px] font-bold uppercase tracking-[0.2em] px-3 py-1 rounded-full mb-3"
           style={{ background: "var(--pr-tint-gold)", color: "var(--pr-ink)" }} data-testid={`${id}-label`}>
          <Lock className="w-3 h-3" /> Season Pass feature
        </p>
        <h1 className="text-2xl sm:text-3xl mb-2" style={{ fontFamily: "'Fraunces', Georgia, serif", color: "var(--pr-ink)" }}>{title}</h1>
        <p className="text-sm leading-relaxed mb-4" style={{ color: "var(--pr-ink2)" }} data-testid={`${id}-body`}>{body}</p>
        {bullets.length > 0 && (
          <ul className="text-left text-xs leading-relaxed space-y-1.5 mb-5 mx-auto max-w-xs" style={{ color: "var(--pr-ink2)" }}>
            {bullets.map((b) => <li key={b}>🏁 {b}</li>)}
          </ul>
        )}
        <Link to="/start/season-pass" className="inline-block px-7 py-3 rounded-full font-bold text-sm pr-btn-primary" data-testid={`${id}-cta`}>
          {ctaLabel} →
        </Link>
        <p className="text-[11px] mt-3" style={{ color: "var(--pr-muted)" }}>Your Sprint keeps running. Nothing you've logged changes.</p>
      </div>
      <p className="text-xs mt-4 text-center">
        <Link to={backTo} className="underline" style={{ color: "var(--pr-muted)" }} data-testid={`${id}-back`}>← Back to the race</Link>
      </p>
    </div>
  </div>
);
